import { render, staticRenderFns } from "./VideoSection.vue?vue&type=template&id=b6a878ac&scoped=true&"
import script from "./VideoSection.vue?vue&type=script&lang=js&"
export * from "./VideoSection.vue?vue&type=script&lang=js&"
import style0 from "./VideoSection.vue?vue&type=style&index=0&id=b6a878ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a878ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6a878ac')) {
      api.createRecord('b6a878ac', component.options)
    } else {
      api.reload('b6a878ac', component.options)
    }
    module.hot.accept("./VideoSection.vue?vue&type=template&id=b6a878ac&scoped=true&", function () {
      api.rerender('b6a878ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/VideoSection.vue"
export default component.exports